import * as Action from "@actions/index";

const InitialState = {
  status: "loading",
  data: null,
  error: "",
};

export default function CompanyCurrent(state = InitialState, action: any) {
  switch (action.type) {
    case Action.Company.Current.SET_DATA:
      return { ...state, data: action.data };
    case Action.Company.Current.SET_STATUS:
      return { ...state, status: action.data };
    case Action.Company.Current.SET_ERROR:
      return { ...state, error: action.data };
    case Action.Company.Current.CLEAR:
      return { ...state, data: {} };
    default:
      return state;
  }
}
